import * as React from "react";
import ReactMarkdown from "react-markdown";
import style from "./style.module.css";

type MarkdownPreviewProps = {
  source: string;
};

function MarkdownPreview({ source }: MarkdownPreviewProps) {
  return (
    <div className={style.container}>
      <ReactMarkdown linkTarget="_blank" source={source} escapeHtml={false} />
    </div>
  );
}

export default MarkdownPreview;
